<section class="reward-listing">
  <div class="container bb-m">
    <div class="row">
      <div class="col-md-8 title">
        <p class="cancel d-block d-md-none" (click)="closeSheet()" >CANCEL</p>
        <h2>Earned Rewards</h2>
      </div>
      <div class="col-md-4 title text-right d-m-none">
        <span class="cancel d-none d-sm-block" (click)="closeSheet()">
            CANCEL
        </span>
      </div>
    </div>
  </div>
  <div class="container p-m">
    <div class="row">
      <div class="col-12 col-md-6 col-lg-4  mt-4" *ngFor= "let data of msrRewardsData">
        <app-reward-card [data]="data"></app-reward-card>
      </div>
    </div>
  </div>
</section>